import { render, staticRenderFns } from "./EstablishmentForm.vue?vue&type=template&id=0cb5c540&scoped=true"
import script from "./EstablishmentForm.vue?vue&type=script&lang=js"
export * from "./EstablishmentForm.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentForm.vue?vue&type=style&index=0&id=0cb5c540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5c540",
  null
  
)

export default component.exports